import { render, staticRenderFns } from "./PBottomFloatingButtonGroup.vue?vue&type=template&id=18c459cf&"
import script from "./PBottomFloatingButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./PBottomFloatingButtonGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports